import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { authApi } from './services/authApi';
import Swal from 'sweetalert2';
import { useLang } from './i18n/context';
import BrandMark from './components/BrandMark';

function ForgotPassword() {
  const navigate = useNavigate();
  const { t } = useLang();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [emailChecked, setEmailChecked] = useState(false);

  const validateEmail = (value) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);

  const handleEmailBlur = () => {
    if (email && !validateEmail(email)) setEmailError(t('forgot.validEmail'));
    else setEmailError('');
  };

  const handleCheckEmail = () => {
    if (!email) { setEmailError(t('forgot.enterEmail')); return; }
    if (!validateEmail(email)) { setEmailError(t('forgot.validEmail')); return; }
    // 平迁：后端 reset-password 不暴露邮箱是否注册，前端不再查询，格式通过即进入下一步
    setEmailChecked(true);
    setEmailError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword || newPassword.length < 8) {
      Swal.fire({ icon: 'warning', title: t('forgot.passwordRequirement'), text: t('forgot.passwordTooShort'), background: '#1e222d', color: '#d1d4dc', confirmButtonColor: '#bfa14a', confirmButtonText: t('forgot.confirm') });
      return;
    }
    if (newPassword !== confirm) {
      Swal.fire({ icon: 'warning', title: t('forgot.passwordMismatch'), text: t('forgot.passwordMismatchMsg'), background: '#1e222d', color: '#d1d4dc', confirmButtonColor: '#bfa14a', confirmButtonText: t('forgot.confirm') });
      return;
    }

    try {
      setSubmitting(true);
      await authApi.resetPassword({ email, newPassword });

      Swal.fire({
        icon: 'success', title: t('forgot.success'),
        text: t('forgot.successMsg'),
        background: '#1e222d', color: '#d1d4dc',
        confirmButtonColor: '#bfa14a', confirmButtonText: t('forgot.goToLogin'),
      }).then(() => navigate('/login'));
    } catch (err) {
      Swal.fire({
        icon: 'error', title: t('forgot.failed'),
        text: err?.message || t('forgot.retryLater'),
        background: '#1e222d', color: '#d1d4dc',
        confirmButtonColor: '#ef5350', confirmButtonText: t('forgot.confirm'),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-form">
      <div className="auth-logo">
        <BrandMark className="auth-logo-mark" />
        GHOST
      </div>

      <h1 className="auth-title">{t('forgot.title')}</h1>
      <p className="auth-subtitle">{t('forgot.emailPlaceholder')}</p>

      <form className="auth-card" onSubmit={emailChecked ? handleSubmit : e => e.preventDefault()}>
        <input type="text" placeholder={t('forgot.emailPlaceholder')} value={email} onChange={e => setEmail(e.target.value)} disabled={emailChecked} onBlur={handleEmailBlur} className={emailError ? 'input-error' : ''} />
        {emailError && <div className="input-error-text">{emailError}</div>}

        {!emailChecked ? (
          <button type="button" className="auth-submit" onClick={handleCheckEmail}>{t('forgot.nextStep')}</button>
        ) : (
          <>
            <input type="password" placeholder={t('forgot.newPasswordPlaceholder')} value={newPassword} onChange={e => setNewPassword(e.target.value)} />
            <input type="password" placeholder={t('forgot.confirmPasswordPlaceholder')} value={confirm} onChange={e => setConfirm(e.target.value)} />
            <button type="submit" className="auth-submit" disabled={submitting}>{submitting ? t('forgot.submitting') : t('forgot.submit')}</button>
          </>
        )}
      </form>

      <div className="auth-footer">
        <button className="auth-link" onClick={() => navigate('/login')}>{t('forgot.backToLogin')}</button>
      </div>
    </div>
  );
}

export default ForgotPassword;
